var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4688,
    cy: 20.01,
    r: 20,
    fill: "#62C572"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4688 30.51C26.2677 30.51 30.9688 25.809 30.9688 20.01C30.9688 14.211 26.2677 9.51001 20.4688 9.51001C14.6698 9.51001 9.96875 14.211 9.96875 20.01C9.96875 25.809 14.6698 30.51 20.4688 30.51Z",
    fill: "#62C572"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7656 15.31L18.9656 22.11L16.1656 19.31L14.7656 20.71L18.9656 24.91L27.1656 16.71L25.7656 15.31Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInGreen);
export default __webpack_public_path__ + "static/media/IN_green.b481b1d5435b4e5ea4a61baf68ea9617.svg";
export { ForwardRef as ReactComponent };